import React from "react";
import "./Layout.scss";
import { Outlet } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";

function Layout() {
  return (
    <div className="container w-full max-w-full absolute left-0 right-0 top-0 bottom-0 h-full bg-darkcolor-800 cia-layout">
      {/* <Sidebar /> */}
      <Outlet />
    </div>
  );
}

export default Layout;
